@if (showForcedLogoutWarning$ | async) {
  <ds-message
    tone="caution"
    messageText="{{ forcedLogoutWarning }}"
  ></ds-message>
}

@if (this.sharedService.showUIElements$ | async) {
  <ds-header
    [navBarRef]="navBar"
    appName="{{ title }}"
    [environmentTag]="environmentTagConfig"
    [userInfo]="userInfo"
    [themeSwitch]="true"
    (requestLogout)="handleLogout()"
  >
  </ds-header>
  <div class="d-flex">
    <div class="nav-bar-wrapper position-sticky">
      <ds-navigation-bar #navBar [items]="navigationItems"></ds-navigation-bar>
    </div>
    <main class="centered-items w-100">
      <section class="ds-container-fluid">
        <router-outlet></router-outlet>
        <!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
        <!-- * * * * * * * * * * Keep in mind a ds-container's * * * * * * * * * -->
        <!-- * * * * * * * * * * children should always be rows. * * * * * * * * -->
        <!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
      </section>
    </main>
  </div>
  <!-- } @else { -->
  <!-- <h1
    style="
      font-family:
        'BMWGroupTNCondensedPro-Medium',
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100vh;
    "
  >
    Loading...
  </h1> -->
}

@if (showLoader) {
  <div
    style="
      display: flex;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 111;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;
      height: 100%;
      padding: var(--ds-space-inset-loading-area);
      background-color: var(--ds-color-surface-loading-area-translucent);
      color: var(--ds-color-icon-loading-area-translucent);
    "
  >
    <ds-progress-circle
      style="
        width: 60px;
        height: 60px;
        --ds-progress-circle-stroke-circumference-start: 158.3362697409256;
        --ds-progress-circle-stroke-circumference-end: 105.55751316061705;
        color: white !important;
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        class="ds-progress-circle__svg--spinning"
        width="60"
        height="60"
        viewBox="0 0 58 58"
      >
        <circle
          cx="50%"
          cy="50%"
          class="ds-progress-circle__track"
          r="28"
        ></circle>
        <circle
          cx="50%"
          cy="50%"
          class="ds-progress-circle__indicator spinning"
          r="28"
          style="stroke-dasharray: 175.929"
        ></circle>
      </svg>
    </ds-progress-circle>
  </div>
}
